module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-to-home"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "background"
  }, [_c('img', {
    staticStyle: {
      "filter": "brightness(45%)"
    },
    attrs: {
      "src": _vm.imageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "install-app-container"
  }, [_c('h3', [_vm._v("Install Digital Business Card")]), _vm._v(" "), (_vm.icon_Android) ? _c('div', [_c('div', {
    staticClass: "number"
  }, [_vm._v("1.")]), _vm._v(" Click the "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/options_android.png")
    }
  }), _vm._v(" icon above\n        ")]) : _vm._e(), _vm._v(" "), (_vm.icon_Iphone) ? _c('div', [_c('div', {
    staticClass: "number"
  }, [_vm._v("1.")]), _vm._v(" Click the "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/options_iphone.jpg")
    }
  }), _vm._v(" icon below\n        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.icon_Iphone || _vm.icon_Android) ? _c('div', [_c('div', {
    staticClass: "number"
  }, [_vm._v("2.")]), _vm._v(" Click \"Add to Home Screen\".        \n        ")]) : _vm._e(), _vm._v(" "), (!_vm.icon_Iphone && !_vm.icon_Android) ? _c('div', [_c('p', [_vm._v("Sorry, this browser not supported. Please, copy the app url and open it into another browser (Chrome, Safari).")])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6ddf5f7c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ddf5f7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/add-to-homescreen.vue
// module id = 796
// module chunks = 0